import React from 'react'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from 'recharts'
import { formatScorecardDecimal } from 'helpers/scorecardFormat'

interface Props {
  labelsOfSection: string[]
  //null for scorecards generated before the track had a national average
  sectionWiseTotal?: (number | null)[] | null
  sectionWiseTotalObtained: number[]
  bottomValue: number
}

const formatChartLabel = (value: number | string | null) => (value === null || value === undefined ? '' : formatScorecardDecimal(value))

//align x axis values
const CustomXAxisTick = (props: any) => {
  const { x, y, payload } = props
  const maxWidth = 200
  const maxLines = 3
  const minPadding = 10
  const words = payload.value.split(' ')
  const lines = []
  const ellipsis = '...'
  let currentLine = ''
  words.forEach((word: any) => {
    const testLine = currentLine.length === 0 ? word : `${currentLine} ${word}`
    const testWidth = testLine.length * 8
    if (testWidth > maxWidth) {
      lines.push(currentLine)
      currentLine = word
    } else {
      currentLine = testLine
    }
  })

  lines.push(currentLine)

  return (
    <g transform={`translate(${x},${y})`}>
      {lines.map((line, index) => (
        <text key={index} x={0} y={index * maxLines + minPadding} dy={index > 0 ? 13 : 0} textAnchor="middle" fill="#666" fontSize={11}>
          {line}
        </text>
      ))}
    </g>
  )
}

const SectionWiseChart: React.FC<Props> = ({ labelsOfSection, sectionWiseTotal, sectionWiseTotalObtained, bottomValue }) => {
  const data = labelsOfSection.map((label, index) => ({
    label,
    total: sectionWiseTotal?.[index] ?? null,
    obtained: sectionWiseTotalObtained[index],
  }))
  // Calculate the tick interval based on multiples of 5
  const maxDataValue = Math.max(...(sectionWiseTotal || []).map(value => Number(value) || 0), ...sectionWiseTotalObtained)
  const tickInterval = 10
  const yAxisTicks = Array.from({ length: Math.ceil(maxDataValue / tickInterval) + 1 }, (_, index) => index * tickInterval)
  return (
    <ResponsiveContainer width="100%" height={bottomValue === 30 ? 300 : 250}>
      <BarChart data={data} margin={{ top: 30, right: 30, left: 20, bottom: bottomValue }}>
        <YAxis ticks={yAxisTicks} />
        <Bar dataKey="total" fill="#0C5692" barSize={30} name="Total Score Assigned">
          <LabelList dataKey="total" position="top" formatter={formatChartLabel} style={{ fill: '#363535', fontSize: '12px' }} />
        </Bar>
        <Bar dataKey="obtained" fill="#96C63C" barSize={30} name="Total Score Scored">
          <LabelList dataKey="obtained" position="top" formatter={formatChartLabel} style={{ fill: '#363535', fontSize: '12px' }} />
        </Bar>
        {/* Custom X-axis */}
        <XAxis dataKey="label" tick={<CustomXAxisTick />} interval={0} />
      </BarChart>
    </ResponsiveContainer>
  )
}
export default SectionWiseChart
//------------------------------------------------------------------------
// import React from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,ResponsiveContainer, LabelList } from 'recharts';
// interface Props {
//   labelsOfSection: string[];
//   sectionWiseTotal: number[];
//   sectionWiseTotalObtained: number[];
//   bottomValue:number
// }
// const SectionWiseChart: React.FC<Props> = ({ labelsOfSection, sectionWiseTotal, sectionWiseTotalObtained,bottomValue }) => {
//   const data = labelsOfSection.map((label, index) => ({
//     label,
//     total: sectionWiseTotal[index],
//     obtained: sectionWiseTotalObtained[index],
//   }));
//   const customTickFormatter = (value: string) => {
//     // You can customize the tick format here
//     return value;
//   };
// // Calculate the tick interval based on multiples of 5
//  const maxDataValue = Math.max(...sectionWiseTotal, ...sectionWiseTotalObtained);
//  const tickInterval = 10;
//  const yAxisTicks = Array.from({ length: Math.ceil(maxDataValue / tickInterval) + 1 }, (_, index) => index * tickInterval);
//  return (
//     <BarChart
//       width={600}
//       height={bottomValue===190?400:300}
//       data={data}
//       margin={{ top: 5, right: 30, left: 20, bottom: bottomValue }}
//     >
//       {/* <CartesianGrid strokeDasharray="3 3" /> */}
//       <XAxis
//         dataKey="label"
//         tickFormatter={customTickFormatter}
//         scaleToFit={true}
//         width={50}
//         angle={-90} // Rotate the labels by -45 degrees
//         textAnchor="end" // Anchor the rotated labels at the end
//         tick={{ fill: 'black', fontSize: 12 }}
//       />
//       <YAxis ticks={yAxisTicks} />
//       {/* <Tooltip /> */}
//       {/* <Legend /> */}
//       <Bar dataKey="total"  fill="#0C5692" barSize={30} name='Total Score Assigned'>
//         <LabelList dataKey="total" position="outside" style={{fill:"white"}} />
//       </Bar>
//       <Bar dataKey="obtained" fill="#96C63C" barSize={30} name="Total Score Scored">
//       <LabelList dataKey="obtained" position="outside" style={{fill:"white"}} />
//       </Bar>
//     </BarChart>
//   );
// };
// export default SectionWiseChart;
//-------------------------------------centa---------------------------------------------------------------------------------------------------
// import React from 'react';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import { Doughnut } from 'react-chartjs-2';
// ChartJS.register(ArcElement, Tooltip, Legend);
// interface Props {
//   labelsOfSection: string[];
//   percentageArray: number[];
// }
// const StackedChart: React.FC<Props> = ({ labelsOfSection, percentageArray }) => {
//   const data = {
//     labels: labelsOfSection,
//     datasets: [
//       {
//         label: 'Candidate Performance',
//         data: percentageArray,
//         backgroundColor: [
//           'rgba(255, 99, 132, 0.8)', // Red
//           'rgba(54, 162, 235, 0.8)', // Blue
//           'rgba(255, 206, 86, 0.8)', // Yellow
//           'rgba(75, 192, 192, 0.8)', // Teal
//           'rgba(153, 102, 255, 0.8)', // Purple
//           'rgba(255, 159, 64, 0.8)', // Orange
//         ],
//         borderColor: 'rgba(255, 255, 255, 1)', // White border
//         borderWidth: 2,
//       },
//     ],
//   };
//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: true,
//         position: 'right' as 'right',
//       },
//     },
//   };
//   return (
//     <div style={{ display: 'flex', justifyContent: 'center' }}>
//       <div style={{ padding: 5, position: 'relative', width: '100%' }}>
//         <Doughnut data={data} options={chartOptions} />
//       </div>
//     </div>
//   );
// };
// export default StackedChart;